import React from 'react';
import Navbar from '../components/Navbar';
import './Preturi.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaCar, FaMotorcycle, FaCheckCircle, FaChevronRight, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { IoBus } from "react-icons/io5";
import { Helmet } from 'react-helmet';

// Importă imagini reprezentative (înlocuiește cu rutele tale reale din proiect)
import imgAutoturisme from '../assets/itp-autoturisme.jpg'; 
import imgMotociclete from '../assets/itp-motociclete.jpg';
import imgUtilitare from '../assets/itp-utilitare.jpg';
import imgActe from '../assets/acte-necesaree.jpg';

AOS.init();

const Preturi = () => {
  const documente = {
    autoturisme: ["Certificat de înmatriculare (talon auto)", "Cartea de identitate a proprietarului", "Polița RCA în vigoare"],
    motociclete: ["Certificat de înmatriculare", "Cartea de identitate", "Procura notarială (după caz)", "Polița RCA vigoare", "Dovada plății taxei"],
    utilitare: ["Certificat înmatriculare utilitară", "Cartea de identitate", "Procura notarială", "Polița RCA", "Certificat de omologare"]
  };

  const preturi = [
    {
      categorie: "Autoturisme",
      icon: <FaCar />,
      subcategorii: [
        { tip: "Autoturisme taxi / ride sharing", pret: "180 RON" },
        { tip: "Autoturisme clasice", pret: "200 RON" },
        { tip: "Autoturisme 4x4 / Euro 6", pret: "230 RON" }
      ]
    },
    {
      categorie: "Motociclete & ATV",
      icon: <FaMotorcycle />,
      subcategorii: [
        { tip: "Moto - ATV", pret: "200 RON" }
      ]
    },
    {
      categorie: "Vehicule Utilitare",
      icon: <IoBus />,
      subcategorii: [
        { tip: "Autoutilitare < 3,5 tone", pret: "250 RON" },
        { tip: "Autoutilitare > 3,5 tone", pret: "300 RON" },
        { tip: "Microbuze M2 / Autobuze M3", pret: "250 - 300 RON" },
        { tip: "Utilaje grele", pret: "350 RON" }
      ]
    }
  ];

  return (
    <div className="premium-dark-theme">
      <Navbar />

      <Helmet>
        <title>Servicii ITP București Sector 2 | Inspecție Tehnică Periodică Completă</title>
        <meta name="description" content="Servicii ITP complete în București Sector 2: autoturisme, motociclete, utilitare. Personal certificat RAR. Program: Luni-Vineri 09:00-19:30, Sâmbătă 08:00-13:30. ☎️ +40726104358" />
        <meta name="keywords" content="ITP București Sector 2, inspecție tehnică periodică, ITP autoturisme, ITP motociclete, ITP utilitare, Re-ITP, stație ITP autorizată RAR, verificări tehnice auto, emisii poluante, Șoseaua Electricității 26" />
        <link rel="canonical" href="https://itp-sector2.ro/servicii" />
        {/* Păstrate intacte toate celelalte tag-uri SEO furnizate de tine pentru consistență */}
      </Helmet>

      {/* --- HERO SECTION MODERNE (GLASSMORPHISM) --- */}
      <header className="cyber-hero" data-aos="zoom-out" data-aos-duration="1000">
        <div className="cyber-blur-glow"></div>
        <div className="hero-content-wrapper">
          <span className="cyber-badge">Stație Autorizată RAR</span>
          <h1>Tarife & Documente <br/><span className="text-gradient">Inspecție Tehnică Periodică</span></h1>
          <p>Echipa ITP Sector 2 vă oferă servicii rapide, echipamente de ultimă generație și transparență totală a prețurilor.</p>
        </div>
      </header>

      <main className="bento-grid-container">
        
        {/* --- CARDUL 1: BENTO GRID - AUTOTURISME --- */}
        <div className="bento-card large" data-aos="fade-up">
          <div className="bento-image-side">
            <img src={imgAutoturisme} alt="ITP Autoturisme" />
            <div className="bento-overlay"></div>
            <div className="bento-tag"><FaCar /> Autoturisme</div>
          </div>
          <div className="bento-info-side">
            <h2>Gama Auto & RideSharing</h2>
            <p>Pentru autoturisme de până la 4 ani, verificarea se face la 2 ani. Pentru cele mai vechi de 4 ani, ITP-ul devine obligatoriu anual.</p>
            
            <div className="docs-sub-box">
              <h4><FaCheckCircle className="accent-icon"/> Acte necesare:</h4>
              <ul>
                {documente.autoturisme.map((d, i) => <li key={i}>{d}</li>)}
              </ul>
            </div>
          </div>
        </div>

        {/* --- CARDUL 2: BENTO GRID - REVIZIE DOCUMENTAȚIE --- */}
        <div className="bento-card medium image-only-card" data-aos="fade-up" data-aos-delay="100">
          <img src={imgActe} alt="Verificare documente ITP" className="full-cover-img" />
          <div className="bento-card-caption">
            <h3>Pregătit pentru inspecție?</h3>
            <p>Asigură-te că ai actele în original înainte de a te prezenta la stația din Șoseaua Electronicii.</p>
          </div>
        </div>

        {/* --- CARDUL 3: BENTO GRID - MOTO --- */}
        <div className="bento-card normal" data-aos="fade-up">
          <div className="bento-image-side compact">
            <img src={imgMotociclete} alt="ITP Motociclete" />
            <div className="bento-tag"><FaMotorcycle /> Moto & ATV</div>
          </div>
          <div className="bento-info-side">
            <h2>Motociclete</h2>
            <p>Inspecție obligatorie anuală pentru siguranța ta pe două roți.</p>
            <ul className="mini-docs-list">
              {documente.motociclete.slice(0,3).map((d, i) => <li key={i}><FaChevronRight/> {d}</li>)}
            </ul>
          </div>
        </div>

        {/* --- CARDUL 4: BENTO GRID - UTILITARE --- */}
        <div className="bento-card large inverse-layout" data-aos="fade-up">
          <div className="bento-info-side">
            <h2>Vehicule Utilitare & Camioane</h2>
            <p>Verificări riguroase pentru flote comerciale, microbuze și utilaje grele.</p>
            <div className="docs-sub-box">
              <h4><FaCheckCircle className="accent-icon"/> Acte obligatorii:</h4>
              <ul>
                {documente.utilitare.map((d, i) => <li key={i}>{d}</li>)}
              </ul>
            </div>
          </div>
          <div className="bento-image-side">
            <img src={imgUtilitare} alt="ITP Autoutilitare" />
            <div className="bento-overlay"></div>
            <div className="bento-tag"><IoBus /> Utilitare</div>
          </div>
        </div>

      </main>

      {/* --- SECȚIUNEA NOUĂ: GRID DE PREȚURI FUTURIST --- */}
      <section className="pricing-cyber-section">
        <div className="pricing-header-center">
          <h2>Lista Oficială de Tarife</h2>
          <p>Plata se poate efectua Cash, Card sau Transfer Bancar. Fără taxe ascunse.</p>
        </div>

        <div className="pricing-neon-grid">
          {preturi.map((p, idx) => (
            <div className="pricing-neon-card" key={idx} data-aos="zoom-in" data-aos-delay={idx * 100}>
              <div className="pricing-card-glow"></div>
              <div className="card-head">
                <span className="icon-sphere">{p.icon}</span>
                <h3>{p.categorie}</h3>
              </div>
              <div className="card-prices-list">
                {p.subcategorii.map((sub, i) => (
                  <div className="price-row" key={i}>
                    <span className="row-title">{sub.tip}</span>
                    <span className="row-price">{sub.pret}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* --- SECȚIUNEA CONTACT RAPID / CTA --- */}
      <section className="cyber-cta-footer" data-aos="fade-up">
        <div className="cta-inner-card">
          <h2>Evită amenzile. Verifică valabilitatea ITP-ului tău astăzi!</h2>
          <p>Suntem localizați convenabil în Sectorul 2, București.</p>
          
          <div className="cta-info-bar">
            <div className="info-pill"><FaMapMarkerAlt /> Șoseaua Electronicii 24</div>
            <div className="info-pill"><FaPhoneAlt /> 0726 104 358</div>
          </div>

          <div className="cta-action-buttons">
            <a href="tel:+40726104358" className="btn-neon-pulse">Sună pentru Programare</a>
            <a href="/contact" className="btn-secondary-dark">Vezi pe Hartă</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Preturi;